import { render, staticRenderFns } from "./CustomerDocumentsExternalAccess.vue?vue&type=template&id=97de4e96"
import script from "./CustomerDocumentsExternalAccess.vue?vue&type=script&lang=js"
export * from "./CustomerDocumentsExternalAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports